/* ============================================
   Artemis Theme — Saved Designs API client
   ============================================
   window.ArtemisDesigns — talks to the Shopify App Proxy path (same-origin,
   so no CORS). Shopify injects the verified customer id server-side; the
   browser never sends one. Used by both the designer page and the account
   "saved designs" page.

   A 401/403 surfaces as a thrown Error with message 'AUTH' so callers can
   send the customer to sign in.
   ============================================ */

(function () {
  'use strict';

  function proxyBase() {
    var el = document.querySelector('[data-proxy-url]');
    var base = (el && el.getAttribute('data-proxy-url')) || '/apps/designer';
    return base.replace(/\/+$/, '');
  }

  function request(path, opts) {
    return fetch(proxyBase() + path, Object.assign({
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
    }, opts || {})).then(function (res) {
      if (res.status === 401 || res.status === 403) throw new Error('AUTH');
      if (res.status === 204) return null;
      return res.json().catch(function () { return {}; }).then(function (body) {
        if (!res.ok) throw new Error(body.message || body.error || 'Request failed');
        return body;
      });
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatWhen(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  }

  /* Shared list-row markup for the designer-page panel and the account page.
     `design` = { id, name, updated_at }. `handlers`:
       primaryLabel : text for the primary action button (omit for none)
       onPrimary(design)        : primary-button click
       onDelete(design, liEl)   : delete-button click
  */
  function renderRow(design, handlers) {
    handlers = handlers || {};
    var li = document.createElement('li');
    li.className = 'design-row';
    li.setAttribute('data-design-id', design.id);
    li.innerHTML =
      '<div class="design-row__info">' +
        '<span class="design-row__name">' + escapeHtml(design.name) + '</span>' +
        '<span class="design-row__meta">Updated ' + escapeHtml(formatWhen(design.updated_at)) + '</span>' +
      '</div>' +
      '<div class="design-row__actions">' +
        (handlers.primaryLabel
          ? '<button type="button" class="btn btn--sm btn--outline-dark" data-design-primary>' +
              escapeHtml(handlers.primaryLabel) + '</button>'
          : '') +
        '<button type="button" class="design-row__delete" data-design-delete aria-label="Delete design">×</button>' +
      '</div>';
    var primary = li.querySelector('[data-design-primary]');
    if (primary && handlers.onPrimary) {
      primary.addEventListener('click', function () { handlers.onPrimary(design); });
    }
    var del = li.querySelector('[data-design-delete]');
    if (del && handlers.onDelete) {
      del.addEventListener('click', function () { handlers.onDelete(design, li); });
    }
    return li;
  }

  window.ArtemisDesigns = {
    list: function () { return request('/designs'); },
    get: function (id) { return request('/designs/' + encodeURIComponent(id)); },
    save: function (name, board) {
      return request('/designs', { method: 'POST', body: JSON.stringify({ name: name, board: board }) });
    },
    update: function (id, patch) {
      return request('/designs/' + encodeURIComponent(id), { method: 'PUT', body: JSON.stringify(patch) });
    },
    remove: function (id) {
      return request('/designs/' + encodeURIComponent(id), { method: 'DELETE' });
    },
    renderRow: renderRow,
    escapeHtml: escapeHtml,
  };
})();
